import { sendPasswordResetEmail, onIdTokenChanged, updateProfile } from 'firebase/auth';
import { getToken } from "firebase/app-check";
import React, { createContext, useContext, useState, useEffect } from 'react'
import { authSolar, methodsSolar  } from './FirebaseSolar'

const AuthContextSolar = createContext();

export function useAuthSolar() {
    return useContext(AuthContextSolar)
}

export function AuthProviderSolar({ children }) {
    const [currentSolarUser, setCurrentSolarUser] = useState()
    const [loading, setLoading] = useState(true)

    function signup(email, password) {
        return methodsSolar.createUserWithEmailAndPassword(authSolar, email, password)
    }

    function createProfile(name, phone) {
        return updateProfile(authSolar.currentUser, {displayName: name})
    }

    function login(email, password) {
        
        return methodsSolar.signInWithEmailAndPassword(authSolar, email, password)
    }

    
    function logout() {
        return methodsSolar.signOut(authSolar)
    }

    function resetPassword(email) {
        return sendPasswordResetEmail(authSolar, email).then((a) => {
          alert("Password reset email sent")
        })
    }

    function changePassword(password) {
        return currentSolarUser.changePassword(password)
    }

    function updateEmail(email) {
        return currentSolarUser.updateEmail(email)
    }



    useEffect(() => {
        const unsubscribe = methodsSolar.onAuthStateChanged(authSolar, (user) => {
            setCurrentSolarUser(user)
            setLoading(false)
        })
        return unsubscribe 
    })
    
    useEffect(() => {
        const unsubscribeClaim = onIdTokenChanged(authSolar, (user) => {
            setCurrentSolarUser(user); // Update currentUser when token changes
            setLoading(false);
        });
        return unsubscribeClaim;
    }, []);


    const value = {
        currentSolarUser,
        login,
        signup,
        createProfile,
        logout, 
        resetPassword,
        updateEmail,
        changePassword
    }

  return (
    <AuthContextSolar.Provider value={value}>
        {!loading && children}
    </AuthContextSolar.Provider>
  )
}

